import React, { useState } from 'react';
import { Container, TextField, Button, Typography, Paper, Box } from '@mui/material';

function Login({ onLoginSuccess }) {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [errors, setErrors] = useState({});

  const validate = () => {
    const newErrors = {};

    if (!username) {
      newErrors.username = 'Username is required';
    } 

    if (!password) {
      newErrors.password = 'Password is required';
    }

    return newErrors;
  };

  const handleUsernameChange = (e) => {
    setUsername(e.target.value);
    if (errors.username || errors.general) {
      setErrors(prev => ({ ...prev, username: '', general: '' }));
    }
  };

  const handlePasswordChange = (e) => {
    setPassword(e.target.value);
    if (errors.password || errors.general) {
      setErrors(prev => ({ ...prev, password: '', general: '' }));
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const validationErrors = validate();

    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
    } else {
      setErrors({});

      if (username === 'demo' && password === 'demo123') {
        onLoginSuccess();
      } else {
        setErrors({ general: 'Invalid Login Details' });
      }
    }
  };

  return (
    <Container maxWidth="sm">
      <Paper elevation={3} sx={{ padding: 4, marginTop: 8 }}>

      <Typography variant="h5" align="center" gutterBottom>
        VIDISKY - Property Safety & Risk Report
        </Typography>

        <Typography variant="h6" align="center" gutterBottom>
          Login
        </Typography>

       


        {errors.general && (
          <Typography color="error" align="center">{errors.general}</Typography>
        )}

        <form onSubmit={handleSubmit} noValidate>
          <TextField
            fullWidth
            margin="normal"
            label="Username"
            value={username}
            onChange={handleUsernameChange}
            error={!!errors.username}
            helperText={errors.username}
            autoComplete="off" 
          />
          <TextField
            fullWidth
            margin="normal"
            label="Password"
            type="password"
            value={password}
            onChange={handlePasswordChange}
            error={!!errors.password}
            helperText={errors.password}
            autoComplete="new-password" 
          />

          <Box textAlign="center" marginTop={2}>
            <Button type="submit" variant="contained">
              Login
            </Button>
          </Box>
        </form>
      </Paper>
    </Container>
  );
}

export default Login;
